import { useCallback } from 'react';

export interface UseActionButtonsProps {
  onAddRecord: () => void;
  onImport: () => void;
  onExport: () => void;
}

export const useInventoryActionButtons = ({
  onAddRecord,
  onImport,
  onExport,
}: UseActionButtonsProps) => {
  // Handlers para los botones
  const handleAddRecord = useCallback(() => {
    onAddRecord();
  }, [onAddRecord]);

  const handleImport = useCallback(() => {
    onImport();
  }, [onImport]);

  const handleExport = useCallback(() => {
    onExport();
  }, [onExport]);

  return {
    handleAddRecord,
    handleImport,
    handleExport,
  };
};
